import {
  Alert,
  Button,
  Chip,
  Container,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useCallback, useState } from "react";
import PageTitle from "../../../widgets/PageTitle";
import { Link, useNavigate, useParams } from "react-router-dom";
import TitleActionsContainer from "../../../widgets/TitleActionsContainer";
import { debounce } from "lodash";
import SearchIcon from "@mui/icons-material/Search";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import useApiEp from "../../../hooks/useApiEp";
import { getErrorResponse, toastError } from "../../../utils/util";
import DataTable from "../../../widgets/DataTable";
import { useDialog } from "../../../context/DialogContext";
import { Edit } from "@mui/icons-material";
import { GlassButton } from "../../../themes/UiElements";
const ChatbotFlowsList = () => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const { showDialog } = useDialog();
  const [name, setName] = useState("");
  const [deleting, setDeleting] = useState(false);
  const [sq, setSq] = useState("");
  const navigate = useNavigate();
  const debouncedSearch = useCallback(
    debounce((value) => {
      setSq(value);
    }, 500),
    []
  );
  const handleSearchChange = (value) => {
    setName(value);
    debouncedSearch(value);
  };
  const { data, isLoading, isError, error, refetch } = useApiEp(
    `/message/get-chatbot-flow-items?page=${page}&name=${sq}`
  );
  const navigateToDnD = useCallback((id) => {
    navigate(`/${id}/chatbot-flow-builder`);
  }, []);
  const handleDelete = useCallback((itemId) => {
    try {
    } catch (error) {
      toastError(error);
    }
  }, []);
  const handleAction = useCallback((action, id) => {
    switch (action) {
      case "view":
        navigate(`/home/${id}/chatbot-flow-details`);
        break;
      case "edit":
        //navigate(`/home/accounts/${id}/edit-account`);
        break;
      case "delete":
        showDialog(
          "Please confirm",
          "Are you sure you want to delete this ChatBot and all its items?",
          {
            type: "delete",
            onConfirm: async () => {
              handleDelete(id);
            },
          }
        );
        //handleDelete(id);
        break;
      default:
        console.warn("unknown action", id);
    }
  }, []);
  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }

  return (
    <Container sx={{ mt: 3 }}>
      <TitleActionsContainer>
        <PageTitle>Flows List</PageTitle>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1}
          sx={{
            width: { xs: "100%", sm: "auto" },
            mt: { xs: 1, sm: 0 },
          }}
        >
          <TextField
            size="small"
            value={name}
            onChange={(e) => handleSearchChange(e.target.value)}
            placeholder="Search Flows"
            InputProps={{ startAdornment: <SearchIcon fontSize="small" /> }}
          />
          <GlassButton
            onClick={() => {
              navigate(`/home/add-chatbot-flow`);
            }}
            variant="outlined"
            startIcon={<AddOutlinedIcon />}
          >
            Add Flow
          </GlassButton>
        </Stack>
      </TitleActionsContainer>
      <Typography variant="body1">
        For old chatbots refer <Link to="/home/old-chatbots">here</Link>
      </Typography>
      <DataTable
        sx={{ mb: 1 }}
        columns={[
          {
            id: "serial",
            label: "S.No.",
            render: (_v, _row, idx) => (page - 1) * limit + idx + 1,
          },
          { id: "flowName", label: "Name" },
          { id: "flowStarter", label: "Starter" },
          {
            id: "status",
            label: "Status",
            render: (value) => (
              <Chip
                label={value}
                color={value === "published" ? "success" : "default"}
                variant="outlined"
                size="small"
              />
            ),
          },
          {
            id: "_id",
            label: "DnD Builder",
            render: (v) => (
              <Button
                onClick={() => {
                  navigateToDnD(v);
                }}
                startIcon={<Edit />}
                variant="outlined"
                size="small"
              >
                Update
              </Button>
            ),
          },
          {
            id: "createdOn",
            label: "Created On",
            render: (v) =>
              new Date(v).toLocaleString("en-IN", {
                dateStyle: "medium",
              }),
          },
        ]}
        actions={["view", "edit", "delete"]}
        rows={data?.data ?? []}
        page={page}
        itemsPerPage={limit}
        totalPages={data?.totalPages ?? 1}
        onPageChange={setPage}
        onAction={handleAction}
      />
    </Container>
  );
};

export default ChatbotFlowsList;
